// Selectors ==========================================================================================================================================================================
let myTrgBtnSearch = document.querySelector(".my-tgr-btn-search");
let myInputSearch = document.querySelector(".my-input-search");
let myResultFrame = document.querySelector(".my-result-frame");
let myTable = document.querySelector(".my-table");
let myThead = document.querySelector(".my-thead");
let myTbody = document.querySelector(".my-tbody");
let myNoResultFrame = document.querySelector(".my-no-result-frame");
let myCollapseBtnResult = document.querySelector(".my-collapse-btn-result");
// let myCloseBtnResult = document.querySelector(".my-close-btn-result");
let myCloseBtnNoResult = document.querySelector(".my-close-btn-no-result");
let loaderWrapper = document.querySelector(".loader-wrapper");
let myErrorMsg = document.querySelector(".my-error-msg");

// Expand/collapse result
myCollapseBtnResult.addEventListener('click', () => {
    myCollapseBtnResult.classList.toggle('fa-circle-plus')
    myTable.classList.toggle('d-none')
});

// Close result frames
myCloseBtnNoResult.addEventListener('click', () => {
    myNoResultFrame.classList.add('d-none');
});
// myCloseBtnResult.addEventListener('click', () => {
//     myResultFrame.classList.add('d-none');
// });

// Read data =========================================================================================================================================================================

// Read patient ------------------------------------------------------------------------------
myTrgBtnSearch.addEventListener('click', (e) => {
    // Prevent submit of form
    e.preventDefault();
    // Reset no/result-frame
    myResultFrame.classList.add('d-none');
    myNoResultFrame.classList.add('d-none');
    // Reset result collapser
    myCollapseBtnResult.classList.remove('fa-circle-plus');
    myTable.classList.remove('d-none');
    // Read input value
    let inputValue = myInputSearch.value;

    // Validate Patient id not null
    if(inputValue.length != 0) {
        // Hide error msg
        myErrorMsg.classList.add("d-none");
        // Show loader
        loaderWrapper.classList.remove('d-none');
        // Call readPatientAPI function
        readPatientAPI(inputValue);
    } else {
        // Show error msg
        myErrorMsg.classList.remove("d-none");
    }
});

// Read API ----------------------------------------------------------------------------
async function readPatientAPI(inputValue) {
    let response = await fetch(`${process.env.SELFHELP_API}/patients/${inputValue}`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem("token")}` }
    })

    if (response.status != 400 && response.status != 403 && response.status != 404 && response.status != 500 && response.status != 502) {
        let responseParsed = await response.json();

        console.log("API response - Success:");
        console.log(responseParsed);

        parseData(responseParsed);
        //tabulator(responseParsed);                    // Tabulator.js library. Testing.
    } else {
        let responseParsed = await response.json();

        console.log("API response - Error:");
        console.log(responseParsed);

        // Hide loader
        loaderWrapper.classList.add('d-none');
        // Show NO result-frame
        myNoResultFrame.querySelector("span").innerHTML = responseParsed.message;
        myNoResultFrame.classList.remove('d-none');
    }
};

// Render data read -------------------------------------------------------------------------
function parseData(responseParsed) {

    // Hide loader
    loaderWrapper.classList.add('d-none');

    if (responseParsed.detail.length > 0) {

        // Reset table for new data
        myThead.innerHTML = '';
        myTbody.innerHTML = '';

        // To create thead
        let theadArray = Object.keys(responseParsed.detail[0]);                // Create an array of keys for columns (just pick only one records).

        theadArray.forEach(item => {
            if (item != 'products') {   // Filter columns
                myThead.innerHTML += `<th scope="col" class="text-center small px-3">${item}</th>`;
            }
        });

        // To create tbody
        responseParsed.detail.forEach(item => {
            let dataArrayFormat = Object.entries(item); // SUPER USEFUL. Creates an array from object, like: [[UID, 1], [IsActive, false] ...].

            let tdData = '';
            dataArrayFormat.forEach(item => {
                if (item[0] != 'products') {   // Filter columns
                    if (item[0] == 'Birthday') {
                        tdData += `<td class="text-center small px-3 text-nowrap">${item[1].substring(0,10)}</td>`;    // Format date
                    } else {
                        tdData += `<td class="text-center small px-3 text-nowrap">${item[1]}</td>`;
                    }
                }
            });

            myTbody.innerHTML += `<tr>${tdData}</tr>`
        });

        // Show result
        myResultFrame.classList.remove('d-none');

    } else {
        // Show NO result-frame
        myNoResultFrame.classList.remove('d-none');
    }
}

// Optional render library. Testing.
function tabulator(responseParsed) {

    // Hide loader
    loaderWrapper.classList.add('d-none');

    //create Tabulator on DOM element with id "example-table"
    var table = new Tabulator("#example-table", {
        data: responseParsed.detail, //assign data to table
        layout:"fitColumns",
        autoColumns:true,
    });
}
